"use client";

import { createJSONStorage } from "jotai/utils";
import { SyncStorage } from "jotai/vanilla/utils/atomWithStorage";

import { CartValues } from "./types";

// @ts-expect-error localStorage is not inferred exclusively as SyncStorage by Jotai
export const jsonStorage: SyncStorage<CartValues> = createJSONStorage<CartValues>(
  // @ts-expect-error localStorage is not inferred exclusively as SyncStorage by Jotai
  () => {
    if (typeof window === "undefined") return;

    return localStorage;
  },
  {
    reviver(key: keyof CartValues, value: string) {
      if (key === "cartItemsById") {
        try {
          const parsed = JSON.parse(value) as CartValues["cartItemsById"];

          return new Map(Object.entries(parsed));
        } catch (err) {
          return new Map();
        }
      }

      return value;
    },
    replacer(key: keyof CartValues, value: CartValues[keyof CartValues]) {
      if (key === "cartItemsById") {
        if (!(value && value instanceof Map)) return `{}`;

        return JSON.stringify(Object.fromEntries(value?.entries()));
      }

      return value;
    },
  },
);
